export type { ScrollTagProps } from './ScrollTag.types';
export { default } from './ScrollTag';
